import { UserOutlined } from "@ant-design/icons";

export function UserIcon(){
    return <UserOutlined />;
}